import request from '@/utils/request'

// 查询通用业务操作记录列表
export function listOperation(query) {
  return request({
    url: '/web/index/genOperation/list',
    method: 'get',
    params: query
  })
}

// 查询通用业务操作记录详细
export function getOperation(recid) {
  return request({
    url: '/web/index/genOperation/' + recid,
    method: 'get'
  })
}
